import { useState } from 'react';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Button, Menu, MenuItem } from '@mui/material';
import './ResultFilter.css';

function ResultFilter({
  name,
  options = {},
  dimension,
  onOptionChange,
  cn,
  mode = 'pill',
}) {
  const [isOpen, setOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);

  const handleClick = (event) => {
    setOpen(true);
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setOpen(false);
    setAnchorEl(null);
  };

  function onMenuItemClickHandler(dimensionArg, key) {
    setOpen(false);
    onOptionChange(dimensionArg, key);
  }

  const isSidebar = mode === 'sidebar';

  return (
    <div className={`result-filter ${cn || ''}`}>
      {isSidebar ? (
        <div
          className="rf-sidebar-row"
          onClick={handleClick}
          role="button"
          aria-expanded={isOpen}
        >
          <span className="rf-sidebar-label">{name}</span>
          <span className={`rf-sidebar-chevron ${isOpen ? 'open' : ''}`}>
            <ExpandMoreIcon fontSize="small" />
          </span>
        </div>
      ) : (
        <Button
          className='filter-button'
          onClick={handleClick}
          variant="outlined"
          size="small"
          sx={{
            borderRadius: '9999px',
            padding: '5px 16px',
            minWidth: '110px',
            textTransform: 'uppercase',
            fontFamily: 'GothamBold, sans-serif',
            fontWeight: 700,
            fontSize: '12px',
            letterSpacing: '0.06em',
            borderColor: '#20C9FF',
            color: '#0A93D2',
            '&:hover': {
              borderColor: '#0A93D2',
              backgroundColor: '#ffffff'
            }
          }}
        >
          <p style={{ margin: 0 }}>{name}</p>
          <div className={`arrow-icon ${isOpen ? 'arrow-rotated' : ''}`} style={{ marginLeft: 6 }}>
            <ExpandMoreIcon fontSize='large' />
          </div>
        </Button>
      )}

      <Menu
        anchorEl={anchorEl}
        open={isOpen}
        onClose={handleClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        PaperProps={{
          sx: {
            borderRadius: '10px',
            overflow: 'hidden',
            boxShadow: '0 8px 24px rgba(0,0,0,0.12)'
          }
        }}
      >
        <div className={`result-filter__options ${isOpen ? 'open' : ''}`}>
          {Object.entries(options).map(([key, value], index) => (
            <MenuItem
              className='result-filter-item'
              key={index}
              onClick={() => onMenuItemClickHandler(dimension, key)}
            >
              <p style={{ margin: 0 }}>{value}</p>
            </MenuItem>
          ))}
        </div>
      </Menu>
    </div>
  );
}

export default ResultFilter;